<template>
  <svg
    :viewBox="`0 0 ${width} ${height}`"
    :style="{ width: '100%', height: 'auto', display: 'block' }"
    preserveAspectRatio="none"
  >
    <rect
      :width="width"
      :height="height"
      x="0"
      y="0"
      rx="4"
      ry="4"
      fill="#f0f0f0"
    />
    <rect
      :width="width"
      :height="height"
      x="0"
      y="0"
      rx="4"
      ry="4"
      fill="url(#vue-content-loading-gradient)"
    >
      <animate
        attributeName="x"
        :from="`-${width}`"
        :to="String(width)"
        :dur="`${speed}s`"
        repeatCount="indefinite"
      />
    </rect>
    <defs>
      <linearGradient id="vue-content-loading-gradient">
        <stop offset="0%" stop-color="#f0f0f0" stop-opacity="0" />
        <stop offset="50%" stop-color="#e0e0e0" stop-opacity="1" />
        <stop offset="100%" stop-color="#f0f0f0" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "VueContentLoading",
  props: {
    width: { type: [Number, String], default: 400 },
    height: { type: [Number, String], default: 130 },
    speed: { type: [Number, String], default: 2 }
  }
};
</script>
